import React from 'react';
import { ClassAssembly3C2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly3C2026/>;
  };
  
  export default ClassAssemblyPage;